// extracted by mini-css-extract-plugin
export default {"policy":"act-body_policy__0brQ1","fixed-header":"act-body_fixed-header__4i1aC","text":"act-body_text__NKKDY"};